import React from 'react';
import PageLayout from '../../components/common/PageLayout';
import Header from '../../components/common/Header';
import MyBrandsContainer from '../blocks/MyBrandsContainer';

export default function BrandPageContainer() {
  return (
    <PageLayout>
      <Header text="Sellers" />
      <MyBrandsContainer />
    </PageLayout>
  );
}
